import React, {useState, useEffect, useCallback,useContext} from 'react';
import api from '../contexts/BaseUrl'
import './MaterialsExpense.css'
import LeftPanel from '../components/LeftPanel';
import SearchIcon from '../icons/SearchIcon';
import "react-activity/dist/Spinner.css";
import Loading from '../components/Loading';
import { UnitShadeContext } from "../contexts/UnitShadeContext";


function MaterialsExpense(){

    const token = JSON.parse(localStorage.getItem('auth')).token;
    const { unitShadeNo } = useContext(UnitShadeContext);
    const [isLoading, setIsLoading] = useState(false);
   

    const [allSales, setAllSales] = useState([]);

    //search variable
    const [searchSalesAssignedTo, setSearchSalesAssignedTo] = useState('');
    const [dateFrom, setDateFrom] = useState('')
    const [dateTo, setDateTo] = useState('');

    const dateFromObj = dateFrom ? new Date(dateFrom) : null;
    const dateToObj = dateTo ? new Date(dateTo) : null;
    
    const [pageNumber, setPageNumber] = useState(1);
    const [pagination, setPagination] = useState([]);

 


  
    var url;

    if(dateFromObj != null && dateToObj != null && searchSalesAssignedTo.length>0){
        url = `expenses/get-expenses-by-type?unitShadeId=${unitShadeNo}&expenseType=Materials&expenseDescription=${searchSalesAssignedTo}&fromDate=${dateFrom}&toDate=${dateTo}&pageNumber=${pageNumber}&pageSize=40`
    }
    else if(dateFromObj != null && dateToObj != null){
        url = `expenses/get-expenses-by-type?unitShadeId=${unitShadeNo}&expenseType=Materials&fromDate=${dateFrom}&toDate=${dateTo}&pageNumber=${pageNumber}&pageSize=40`
    }
    else if(dateFromObj != null && searchSalesAssignedTo.length>0){
        url = `dailyexpenses/get-all-daily-expenses?unitShadeId=${unitShadeNo}&expenseType=Materials&expenseDescription=${searchSalesAssignedTo}&fromDate=${dateFrom}&pageNumber=${pageNumber}&pageSize=40`
    }
    else if(dateFromObj != null){
        url = `expenses/get-expenses-by-type?unitShadeId=${unitShadeNo}&expenseType=Materials&fromDate=${dateFrom}&pageNumber=${pageNumber}&pageSize=40`
    }
    else if(searchSalesAssignedTo.length>0){
        url = `expenses/get-expenses-by-type?unitShadeId=${unitShadeNo}&expenseType=Materials&expenseDescription=${searchSalesAssignedTo}&pageNumber=${pageNumber}&pageSize=40`
    }
    else{
        url = `expenses/get-expenses-by-type?unitShadeId=${unitShadeNo}&expenseType=Materials&pageNumber=${pageNumber}&pageSize=20` ;
    }


    const handlePageNext = () =>{
        if(pagination.totalPages>pagination.currentPage){
            setPageNumber(pageNumber+1)
        }     
    }

    const handlePagePrevious = () =>{
        if(pageNumber>1){
            setPageNumber(pageNumber-1);
        }
    }

   
    const fetchAllDailyExpenses = useCallback( async () => {
        setIsLoading(true);
        await api.get(url,{
            headers: {Authorization: `Bearer ${token}`}
        }).then(response => {
            setAllSales(response.data);
            setIsLoading(false);
            setPagination(JSON.parse(response.headers.pagination));
        }).catch(err =>{
            setIsLoading(false);
        })
    },[url, token])

    

    useEffect(() => {
        fetchAllDailyExpenses();
    },[fetchAllDailyExpenses])


    
 
    return(
        <div className='materialsExpensePage'> 
    
           <LeftPanel 
                tabName='materials-expense'
           />
           <div id='rightPanel'>
                <div id='rightPanelContent'>
                    <div id='searchAddBox'>
                        <div className='dateBox'>
                            <input
                                type='date' 
                                className='dateInput'
                                onChange={e => setDateFrom(e.target.value)}
                                value={dateFrom}
                            />
                            <div id='to'>To</div>
                            <input
                                type='date' 
                                className='dateInput'
                                onChange={e => setDateTo(e.target.value)}
                                value={dateTo}
                            />

                            <div id='searchBox'>
                                <SearchIcon 
                                    size='24' 
                                    style={{
                                        paddingLeft:10,
                                        paddingTop:8,
                                        position:'absolute',
                                    }} 
                                    color='gray'
                                />
                                <input
                                    placeholder='Search by Expense Description'
                                    id='searchSales'
                                    onChange={(e) => setSearchSalesAssignedTo(e.target.value)}
                                    value={searchSalesAssignedTo}
                                />
                            </div>
                        </div>
                       
                        
                    </div>
                    <div id='tableBox'>
                        {isLoading ? 
                        <Loading /> :
                        <table>
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Expense Type</th>
                                    <th>Description</th>
                                    <th>Amount (Tk)</th>
                                    
                                 
                                </tr>
                                
                            </thead>
                            <tbody>
                            {allSales.map((item, index) =>{
                                return(
                                    <tr key={index}>
                                        <td>{item.expenseDate.substring(0, item.expenseDate.length - 9)}</td>
                                        <td>Materials</td>
                                        <td>{item.expenseDescription}</td>
                                        <td>{item.expenseAmount}</td>
                                        
                                    </tr>
                                )
                            })}
                            </tbody>

                        </table>
                    }
                    <div id='pageChangeBox'>
                        <div id='fixedBox'>
                            <button id='pageChangeButton' onClick={handlePagePrevious}>Back</button>
                            
                            <span>{pageNumber} / {pagination.totalPages}</span>
                            <button id='pageChangeButton' onClick={handlePageNext}>Next</button>
                        </div>    
                        
                    </div>
                    </div>
                </div>
           </div> 
          

        </div>
    )
}

export default MaterialsExpense;